<template>
  <div class="col-md-6 col-lg-4 col-xl-3 mb-5">
    <div class="card h-100 shadow-sm" @click.prevent="showNps">
      <div class="card-body d-flex justify-content-center text-center flex-column p-8">
        <a class="text-gray-800 text-hover-primary d-flex flex-column">
          <div class="symbol symbol-60px mb-5">
            <img src="/assets/media/avatars/form.jpg" alt="">
          </div>
          <div class="fs-5 fw-bolder mb-2">{{nps.title}}</div>
        </a>
        <div class="fs-7 fw-bold text-gray-400">{{ new Date(nps.updated_at)?.toLocaleDateString() }}</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import abilities from "@/composables/abilities";
import {useRouter, useRoute} from "vue-router";

const route = useRoute()
const router = useRouter()

const props = defineProps({
  nps: {
    type: Object,
    default() {
      return {
        id: 1,
        title: "test",
        created_at: "tttt",
      }
    }
  }
})

const showNps = () => {
  router.push({ name: 'events-nps-details', params: { id: route.params.id, nps: props.nps.id }, query: { tab: route.query.tab || 'tab-nps' } });
}


</script>
<style scoped>

.phone-card {
  background-color: #fff !important;
  color: #646E7B !important;
  border-radius: 10px;
  border: 1px solid #646E7B;
  width: 30px;
  height: 30px;
}

.phone-value {
  color: #222222 !important;
  background-color: #F2F3F4 !important;
}

.img-size {
  width: 110px !important;
  height: 110px !important;
  border-radius: 10px;
  object-fit: cover;
  object-position: center;
}

.nps-card {
  height: 330px !important;
  border-radius: 10px;
}

.nps-card:hover {
  border: 2px solid #0072CE;
  border-radius: 10px;
}

.nps-card:hover .img_user{
  background-color: #fff !important;
  color: #0072CE !important;
  border-radius: 10px;
  border: 1px solid #0072CE;
  width: 30px;
  height: 30px;
}

.nps-card:hover .img_user i{
  color: #0072CE !important;
}

.nps-card:hover .img_email{
  background-color: #fff !important;
  color: #F07817 !important;
  border-radius: 10px;
  border: 1px solid #F07817;
  width: 30px;
  height: 30px;
}

.nps-card:hover .img_email i{
  color: #F07817 !important;
}

.nps-card:hover .img_phone{
  background-color: #fff !important;
  color: #2DA333 !important;
  border-radius: 10px;
  border: 1px solid #2DA333;
  width: 30px;
  height: 30px;
}

.nps-card:hover .img_phone i{
  color: #2DA333 !important;
}

.icon-overlay {
    position: absolute;
    bottom: -10px !important;
    left: 50%;
    transform: translateX(-50%);
    color: white;
    border-radius: 50%;
    padding: 8px;
    font-size: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
